import { AlertsVisualizationFilter } from "../interfaces/alerts-visualization-filter.interface";
import { formatCarList } from "./format-car";

export const formatVisualizationFilterPayload = (p: AlertsVisualizationFilter): VisualizationFilterPayload => {

  const params: any = {};

  for (const key in p) {
    const array = p[key];

    if (Array.isArray(array)) {
      if (array.length > 1 && array[0] === "") {
        array.shift();
      } else if (array.length === 1 && array[0] == "") {
        delete p[key];
      }
    }
  }
  p.dataLayer ? (params.layerType = p.dataLayer) : undefined;
  p.detectedClassId ? (params.alertClass = p.detectedClassId) : undefined;
  p.cityId ? (params.citiesIdList = p.cityId) : undefined;
  p.hasEmbargoedAreas ? (params.embargoed = p.hasEmbargoedAreas) : undefined;
  p.TerritoryGroupOptions ? (params.territoryList = p.territoryCrossings.map((tc: any) =>({ id: tc.id, categoria: tc.categoria }))
  ) : undefined;
  p.sources ? (params.sourceList = p.sources) : undefined;
  p.biome ? (params.biomeList = p.biome) : undefined;
  p.ancientVegetation ? (params.ancientVegetation = formatAncientVegetation(p.ancientVegetation)) : undefined;
  p.hasAuthorization ? (params.authorized = p.hasAuthorization) : undefined;
  p.dateStart ? (params.dateStart = p.dateStart.toISOString().slice(0, 10)) : undefined;
  p.dateEnd ? (params.dateEnd = p.dateEnd.toISOString().slice(0, 10)) : undefined;
  p.sizeRange && p.sizeRange[0] ? (params.areaStart = p.sizeRange[0]) : undefined;
  p.sizeRange && p.sizeRange[1] ? (params.areaEnd = p.sizeRange[1]) : undefined;

  p.hasCar ? (params.car = formatCarList(p.hasCar)) : undefined;
  p.hasValidation ? (params.validation = p.hasValidation == '1' ? 'Sim':'Não'): undefined;
  p.hasSupervision ? (params.supervision = [p.hasSupervision]) : undefined;

  // console.log(params);

  return params;
}

const cleanFilter = (filter: any) => {
  Object.keys(filter).forEach(key => {
    if (filter[key] === '') {
      delete filter[key];
    }
  });
  return filter;
}

export const formatAncientVegetation = (category: string) => {
  const ancientVegetation: any[] = JSON.parse(localStorage.getItem('ancientVegetation')) || [];

  const filteredAncientVegetation = ancientVegetation.filter((obj) => {
    return obj['ancientVegetation'] === category;
  });

  const ancientVegetationIds = filteredAncientVegetation.map((obj) => {
    return obj['ancientVegetationId'];
  });

  return ancientVegetationIds;
};

export interface VisualizationFilterPayload {
  // city: string;
  // dateRange: { start: Date; end: Date };

  layerType?: string;
  alertClass?: string[];
  citiesIdList?: string[];
  embargoed?: string;
  territoryList?: {
    id?: number;
    categoria?: string;
  }[];
  sourceList?: string[];
  car?: string;
  authorized?: string;
  validation?: string;
  supervision?: string;
  dateStart?: Date;
  dateEnd?: Date;
  biomeList?: string;
  ancientVegetation?: any[];
  areaStart?: string;
  areaEnd?: string;
}

  export const formatDate = function(date: any){
    let dateFormat =  date
                        .toLocaleDateString("pt-BR")
                        .replaceAll("/", "-")
                        .split('-')
    dateFormat = `${dateFormat[2]}-${dateFormat[1]}-${dateFormat[0]}`;
    return dateFormat;
  }
